import { Group, Modal } from '@mantine/core';
import { AvatarSkeleton, TextSkeleton } from '@repo/foundations';
import { memo } from 'react';
import { MessageGroupSkeleton } from '../../AiChat/components/MessageGroupSkeleton';

export const AiChatPreviewModalSkeleton = memo(() => (
	<Modal.Content>
		<Modal.Header>
			<Modal.Title>
				<Group spacing="sm">
					<AvatarSkeleton />
					<TextSkeleton width={250} />
				</Group>
			</Modal.Title>
			<Modal.CloseButton />
		</Modal.Header>
		<Modal.Body>
			<MessageGroupSkeleton />
		</Modal.Body>
	</Modal.Content>
));
